module.exports = __webpack_public_path__ + "296fa66f318b12fe66d7009e96b8f8e1.webp";